import { getItem } from "tools/localStorage";
import { LocalStorageProduct } from "ts/api/product";

export const getCartCount = (): number => {
  const cartProducts = getItem<LocalStorageProduct[]>("products", []);

  return cartProducts.reduce((acc, curr) => acc + curr.cartQuantity, 0);
};
